import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { profileSlice } from "redux/features/profile";
import { changesSlice, changesSubslice } from "redux/features/changes";
import { RESOURCE_TYPE_PERSON } from "redux/typeConstants";
import { useEmailChangesInProgress } from "hooks/emailChanges";
import { Message } from "react-bulma-components";
import IconButton from "util/iconButton";
import { FaEdit } from "react-icons/fa";

import assessEmails from "util/assessEmails";

export function BasicSummary() {
  const { id, data } = useSelector(profileSlice.selector);
  const changeRecords = useSelector(changesSlice.selector);
  const nameChangeRecords = changesSubslice(
    changeRecords,
    id,
    "name",
    RESOURCE_TYPE_PERSON,
    id
  );
  const { emailChangeRecords } = useEmailChangesInProgress(id);
  const navigate = useNavigate();

  const firstNameClass = data.surname_is_first_name ? "surname" : "given-name";
  const lastNameClass = data.surname_is_first_name ? "given-name" : "surname";

  const { primaryEmail, alternateEmails } = assessEmails(data);

  const showEmail = (email) => (
    <Fragment>
      {email.address}
      {email.institution ? (
        <span className="email-at-institution">
          {" "}
          (at {email.institution}
          {email.shared ? ", shared" : null})
        </span>
      ) : email.shared ? (
        <span className="shared"> (shared)</span>
      ) : null}
    </Fragment>
  );
  return (
    <Message>
      <Message.Header>Basic Information: Name and E-mail</Message.Header>
      <Message.Body className="basic-summary">
        <div className="name">
          {data.honorific ? data.honorific + " " : null}
          {data.first_name ? (
            <span className={firstNameClass}>{data.first_name + " "}</span>
          ) : null}
          <span className={lastNameClass}>{data.last_name}</span>
        </div>

        {nameChangeRecords ? (
          <div className="unsaved-changes-message">
            You have unsaved name changes
          </div>
        ) : null}
        <div className="buttons">
          <IconButton icon={FaEdit} onClick={(e) => navigate("basic/name")}>
            {nameChangeRecords ? "Resume Editing" : "Edit Name"}
          </IconButton>
        </div>

        {primaryEmail ? (
          <div className="email">{showEmail(primaryEmail)}</div>
        ) : data.primary_email_address ? (
          <div className="no-email">
            no current contact e-mail address (one provided previously appears
            out of date)
          </div>
        ) : (
          <div className="no-email">no contact e-mail address provided</div>
        )}

        {alternateEmails.length > 0 ? (
          <div className="other-emails">
            Alternate emails:{" "}
            {alternateEmails.map((e, index) => (
              <Fragment key={e.address}>
                {index > 0 ? ", " : null}
                {showEmail(e)}
              </Fragment>
            ))}
          </div>
        ) : null}
        {emailChangeRecords ? (
          <div className="unsaved-changes-message">
            You have unsaved e-mail address changes
          </div>
        ) : null}
        <div className="buttons">
          <IconButton icon={FaEdit} onClick={(e) => navigate("basic/emails")}>
            {emailChangeRecords ? "Resume Editing" : "Edit Email Addresses"}
          </IconButton>
        </div>
      </Message.Body>
    </Message>
  );
}

export default BasicSummary;
